'use client';
var classes = {"tooltip":"m-1b3c8819","arrow":"m-f898399f"};

export { classes as default };
//# sourceMappingURL=Tooltip.module.css.mjs.map
